'use client';

import { SingleCombobox } from '@commenda/kakashi';
import { FormsTemplateStatus } from '@commenda/types';
import {
  MIXPANEL_EVENTS,
  MIXPANEL_SURFACE_AREA,
} from '@commenda/mixpanel';
import mixpanel from '@commenda/mixpanel';
import { STATUS_EDIT_OPTIONS } from '../constants';

interface EditableStatusCellProps {
  id: string;
  status: FormsTemplateStatus;
  onUpdate: (id: string, newStatus: FormsTemplateStatus) => void;
  size?: 'sm' | 'md' | 'lg';
}

export function EditableStatusCell({
  id,
  status,
  onUpdate,
  size = 'sm',
}: EditableStatusCellProps) {
  const sizeClass =
    size === 'sm' ? 'h-[32px]' : size === 'md' ? 'h-[40px]' : 'h-[48px]';
  return (
    <div onClick={(e) => e.stopPropagation()}>
      <SingleCombobox
        options={STATUS_EDIT_OPTIONS}
        searchPlaceholder="Search status"
        value={status}
        setValue={(val) => {
          if (val === 'LIVE' && status !== 'LIVE') {
            try{
            mixpanel?.track(MIXPANEL_EVENTS.FORM_PUBLISHED, {
              surface_area: MIXPANEL_SURFACE_AREA.WORKFLOW_AND_FORM_BUILDER,
              form_id: id,
            });
            } catch (error) {
              console.error('Failed to track form published event:', error);
            }
          }
          onUpdate(id, val as FormsTemplateStatus);
        }}
        id={`status-${id}`}
        _className={`${sizeClass} min-w-[180px]`}
      />
    </div>
  );
}
